import { Design } from '../document2/page/surface/design/design';

// ユーザー設定クラス

export class UserConfig
{
    // 塗り足しサイズ
    public bleedSize : number = 3.0;
    // 印刷位置調整(表面)
    public printVerticalDirection = "up";
    public printVerticalPosition : number = 0;
    public printHorizontalDirection = "right";
    public printHorizontalPosition : number = 0;
    // 印刷位置調整(裏面)
    public printVerticalDirectionReverse = "up";
    public printVerticalPositionReverse : number = 0;
    public printHorizontalDirectionReverse = "right";
    public printHorizontalPositionReverse : number = 0;
    // 印刷倍率(%)
    // mobileのみ
    public printRate = 100;
    // 反転印刷
    public isPrintFlip : boolean = false;
    // 枠あり印刷
    public isPrintBorder : boolean = false;
    // 両面印刷
    public isPrintDoubleSides : boolean = false;
    // 素材デザイン
    public designMaterials : Array<Design> = new Array();
    // 差し込みの元ドキュメント
    public insertionDocument : Document | null = null;
    // ラスター印刷する
    public printRaster ; boolean = false;
    // ラスター印刷時の印刷クオリティ
    // 1: 360dpi 2: 288dpi 3:216dpi
    public printQuality : number = 1;
    public getPrintDpi()
    {
        if(this.printQuality == 1) return 360;
        else if(this.printQuality == 2) return 288;
        else return 216;
    }

    // mobile: 最後に出力したPDF(base64)
    public exportedPDF : string = "";
    // DL: 最後に出力した画像(base64)
    public exportedImage : string = "";

    // 表の横方向印刷位置
    public offsetFrontX(): number {
        if (this.printHorizontalDirection === 'right') {
            return this.printHorizontalPosition;
        }
        return -this.printHorizontalPosition;
    }

    // 表の縦方向印刷位置
    public offsetFrontY(): number {
        // Xとは正負が逆になるが、デフォルトの値に合わせる
        if (this.printVerticalDirection === 'up') {
            return -this.printVerticalPosition;
        }
        return this.printVerticalPosition;
    }

    // 裏の横方向印刷位置
    public offsetBackX(): number {
        if (this.printHorizontalDirectionReverse === 'right') {
            return this.printHorizontalPositionReverse;
        }
        return -this.printHorizontalPositionReverse;
    }

    // 裏の縦方向印刷位置
    public offsetBackY(): number {
        // Xとは正負が逆になるが、デフォルトの値に合わせる
        if (this.printVerticalDirectionReverse === 'up') {
            return -this.printVerticalPositionReverse;
        }
        return this.printVerticalPositionReverse;
    }
}
